import React, { useEffect, useState } from "react";
import { BookOpen, Gift, Bell, ArrowRight, Calendar, Clock } from "react-feather";
import { useNavigate } from "react-router-dom";
import "./WhatsNew.scss";

const BASE_URL = process.env.REACT_APP_API_URL;
const BLOG_WEBSITE_BASE = "https://www.learnwithtutoria.com/blog";

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const getTimeRemaining = (endTime) => {
  if (!endTime) return null;
  const diff = new Date(endTime) - new Date();
  if (diff <= 0) return null;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  if (days > 0) return `${days}d ${hours}h left`;
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (hours > 0) return `${hours}h ${minutes}m left`;
  return `${minutes}m left`;
};

const WhatsNew = ({ courseId }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOfferId, setExpandedOfferId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const blogParams = new URLSearchParams({ pageSize: 3, pageNumber: 0 });
        if (courseId) blogParams.append("courseId", courseId);

        const offerParams = new URLSearchParams({
          pageSize: 3,
          pageNumber: 0,
          activeOnly: "1",
        });
        if (courseId) offerParams.append("courseId", courseId);

        const [blogRes, offerRes] = await Promise.allSettled([
          fetch(`${BASE_URL}/blogs_public?${blogParams.toString()}`).then(
            (r) => r.json()
          ),
          fetch(`${BASE_URL}/offers_public?${offerParams.toString()}`).then(
            (r) => r.json()
          ),
        ]);

        const blogs = (
          blogRes.status === "fulfilled" ? blogRes.value?.blogs || [] : []
        ).map((b) => ({ ...b, _type: "blog" }));

        const offers = (
          offerRes.status === "fulfilled" ? offerRes.value?.offers || [] : []
        ).map((o) => ({ ...o, _type: "offer" }));

        // Merge and sort by createdAt desc, take top 5
        const merged = [...blogs, ...offers]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 5);

        setItems(merged);
      } catch (error) {
        console.error("Error fetching WhatsNew data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [courseId]);

  const handleBlogClick = (blog) => {
    const url = `${BLOG_WEBSITE_BASE}/${blog.slug}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="whats-new-card">
        <div className="whats-new-list d-flex align-items-center justify-content-center">
          <span
            style={{ fontSize: "13px", color: "#9ca3af", padding: "20px" }}
          >
            Loading...
          </span>
        </div>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="whats-new-card">
        <div className="whats-new-list d-flex align-items-center justify-content-center">
          <span
            style={{ fontSize: "13px", color: "#9ca3af", padding: "20px" }}
          >
            Nothing new yet
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="whats-new-card">
      <div className="whats-new-list">
        {items.map((item) =>
          item._type === "blog" ? (
            <div
              key={item._id}
              className="whats-new-item blog-item"
              onClick={() => handleBlogClick(item)}
            >
              <div className="item-icon-wrap">
                <BookOpen size={15} />
              </div>
              <div className="item-content">
                <div className="item-title">{item.title}</div>
                <div className="item-meta">
                  <span className="item-type-label blog-label">Blog</span>
                  <span className="item-date">
                    <Calendar size={10} />
                    {formatDate(item.createdAt)}
                  </span>
                </div>
              </div>
              <button className="item-arrow">
                <ArrowRight size={14} />
              </button>
            </div>
          ) : (
            <div key={item._id} className={`offer-item-wrap ${item.tag === "News" ? "news-item-wrap" : ""}`}>
              <div
                className={`whats-new-item ${item.tag === "News" ? "news-item" : "offer-item"}`}
                onClick={() =>
                  setExpandedOfferId(
                    expandedOfferId === item._id ? null : item._id
                  )
                }
              >
                <div className="item-icon-wrap">
                  {item.tag === "News" ? <Bell size={15} /> : <Gift size={15} />}
                </div>
                <div className="item-content">
                  <div className="item-title">{item.title}</div>
                  <div className="item-meta">
                    <span className={`item-type-label ${item.tag === "News" ? "news-label" : "offer-label"}`}>{item.tag || "Offer"}</span>
                    <span className="item-date">
                      <Calendar size={10} />
                      {formatDate(item.createdAt)}
                    </span>
                    {item.endTime && getTimeRemaining(item.endTime) && (
                      <span className="item-validity">
                        <Clock size={10} style={{ marginRight: "2px" }} />
                        {getTimeRemaining(item.endTime)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {expandedOfferId === item._id && (
                <div
                  className="offer-expanded"
                  style={{ borderLeftColor: item.tag === "News" ? "#3b82f6" : "#f59e0b" }}
                >
                  <div className="offer-expanded-title">Offer Details</div>
                  <div dangerouslySetInnerHTML={{ __html: item.offerText }} />
                </div>
              )}
            </div>
          )
        )}
      </div>
      <div
        className="view-all-link"
        onClick={() => navigate("/student/whats-new")}
      >
        View All <ArrowRight size={13} />
      </div>
    </div>
  );
};

export default WhatsNew;
